import styled from 'styled-components'
import { Col } from 'antd'

export const ColumnTitle = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
`

// เส้นคั่นหน้าคอลัมน์ (ยุบเป็นแถวเดียวบนจอแคบ เส้นหายเอง)
export const DividedColumn = styled(Col)`
    @media (min-width: 768px) {
        border-left: 1px solid #f0f0f0;
    }
`

export const EmptyHint = styled.div`
    color: rgba(0, 0, 0, 0.45);
    font-size: 13px;
    padding: 16px;
    background: #fafafa;
    border: 1px dashed #e8e8e8;
    border-radius: 4px;
    text-align: center;
`

export const SummaryBox = styled.div`
    margin-top: 24px;
    padding: 12px 14px;
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    font-size: 12px;
`

export const SummaryRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 3px 0;
    color: rgba(0, 0, 0, 0.45);

    ${({ $total }) => $total && `
        margin-top: 4px;
        padding-top: 8px;
        border-top: 1px solid #f0f0f0;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
    `}
`

export const FooterRow = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
    border-top: 1px solid #f0f0f0;
`

export const FieldLabel = styled.div`
    color: rgba(0, 0, 0, 0.85);
    padding-bottom: 8px;
`

export const SwitchRow = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 6px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
`

export const ModeLink = styled.button.attrs({ type: 'button' })`
    border: none;
    background: none;
    padding: 0 0 1px;
    cursor: pointer;
    font-size: 12px;
    color: ${({ $active }) => ($active ? '#1890ff' : 'rgba(0, 0, 0, 0.45)')};
    border-bottom: 1px solid ${({ $active }) => ($active ? '#1890ff' : 'transparent')};

    &:hover {
        color: #1890ff;
    }
`

export const QuickPickRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-bottom: 12px;

    .ant-input-affix-wrapper {
        flex: 1;
        min-width: 140px;
    }
`

export const QuickPickTag = styled.button.attrs({ type: 'button' })`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    line-height: 20px;
    padding: 1px 10px;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid ${({ $active, $partial }) => ($active || $partial ? '#1890ff' : '#d9d9d9')};
    color: ${({ $active, $partial }) => ($active || $partial ? '#1890ff' : 'rgba(0, 0, 0, 0.65)')};
    background: ${({ $active }) => ($active ? '#e6f7ff' : '#fff')};
    border-style: ${({ $partial }) => ($partial ? 'dashed' : 'solid')};

    &:hover {
        border-color: #1890ff;
        color: #1890ff;
    }
`

// ลิสต์สูงคงที่ + scroll ในตัว เพื่อไม่ให้ modal ยืดตามจำนวนพาร์ทเนอร์
export const PickerBox = styled.div`
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    height: ${({ $height }) => $height || 260}px;
    overflow-y: auto;
    ${({ $empty }) => $empty && 'display: flex; align-items: center; justify-content: center;'}
`

export const ValueRow = styled.div`
    padding: 6px 10px;
    border-bottom: 1px solid #f5f5f5;

    &:hover {
        background: #f5f5f5;
    }
`

export const ValueHead = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;

    .ant-checkbox-wrapper {
        align-items: flex-start;
        line-height: 1.4;
    }

    .ant-checkbox {
        top: 2px;
    }

    /* salary_date เป็น free text ที่ต่างกันแค่จำนวนช่องว่าง ถ้าปล่อยให้ HTML ยุบช่องว่าง
       หลายค่าจะแสดงผลเหมือนกันเป๊ะจนแยกไม่ออกว่าอันไหนคืออันไหน */
    .ant-checkbox-wrapper > span:last-child {
        white-space: pre-wrap;
    }
`

export const ValuePartners = styled.div`
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    padding-left: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const GroupRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 6px 10px;
    background: #fafafa;
    border-bottom: 1px solid #f0f0f0;
    position: sticky;
    top: 0;
    z-index: 1;

    .ant-checkbox-wrapper {
        font-weight: 500;
    }
`

export const GroupMeta = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
`

export const CollapseButton = styled.button.attrs({ type: 'button' })`
    display: flex;
    align-items: center;
    border: none;
    background: none;
    padding: 2px;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.45);
    font-size: 11px;

    &:hover {
        color: #1890ff;
    }
`

export const PartnerRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 5px 10px 5px 24px;

    &:hover {
        background: #f5f5f5;
    }
`

export const PartnerVersion = styled.span`
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    flex-shrink: 0;
`

export const PickerFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding-top: 6px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
`

export const LinkButton = styled.button.attrs({ type: 'button' })`
    border: none;
    background: none;
    padding: 0 0 0 12px;
    cursor: pointer;
    color: ${({ disabled }) => (disabled ? 'rgba(0, 0, 0, 0.25)' : '#1890ff')};

    &:hover {
        color: ${({ disabled }) => (disabled ? 'rgba(0, 0, 0, 0.25)' : '#40a9ff')};
    }
`
